import RestModel from './RestModel';

const resourceName = 'config';

export default {
    edit: resource => RestModel.create(resourceName, resource),

    read: () => RestModel.list(resourceName).then(c => c || { title: '', catchPhrase: '', analyticsCode: '', picture: null })
};
